import { render, staticRenderFns } from "./ConcernIndustryNewsList.vue?vue&type=template&id=13b758f2&scoped=true"
import script from "./ConcernIndustryNewsList.vue?vue&type=script&lang=js"
export * from "./ConcernIndustryNewsList.vue?vue&type=script&lang=js"
import style0 from "./ConcernIndustryNewsList.vue?vue&type=style&index=0&id=13b758f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b758f2",
  null
  
)

export default component.exports